<!-- 顶栏消息通知 -->
<template>
  <ele-popover
    :width="336"
    trigger="click"
    transition="el-zoom-in-top"
    :content-style="{ padding: 0 }"
    :body-style="{ overflow: 'hidden' }"
    :popper-style="{ maxWidth: 'calc(100% - 32px)' }"
    :popper-options="{
      strategy: 'fixed',
      modifiers: [{ name: 'offset', options: { offset: [0, 5] } }]
    }"
  >
    <template #reference>
      <div style="display: flex; align-items: center; height: 100%">
        <el-badge
          :value="unreadNum"
          :hidden="!unreadNum"
          style="line-height: 1; padding: 4px 0"
        >
          <el-icon style="transform: scale(1.17) translateY(1px)">
            <BellOutlined />
          </el-icon>
        </el-badge>
      </div>
    </template>
    <ele-tabs
      ref="tabRef"
      :center="true"
      v-model="active"
      :items="[
        { name: 'notice', label: '通知' },
        { name: 'letter', label: '私信' },
        { name: 'todo', label: '待办' }
      ]"
      class="notice-tabs"
    >
      <template #label="{ item, label }">
        <span>{{ label }}</span>
        <span v-if="item.name === 'notice' && notice.length">
          ({{ notice.length }})
        </span>
        <span v-if="item.name === 'letter' && letter.length">
          ({{ letter.length }})
        </span>
        <span v-if="item.name === 'todo' && todo.length">
          ({{ todo.length }})
        </span>
      </template>
      <template #notice>
        <div class="list-wrapper">
          <div v-for="item in notice" :key="item.id" class="list-item">
            <div class="list-item-icon">
              <el-icon>
                <component :is="item.titleIcon || 'IconElDocument'" />
              </el-icon>
            </div>
            <div class="list-item-body" @click="handleNoticesPreview(item)">
              <ele-ellipsis>{{ item.title }}</ele-ellipsis>
              <ele-ellipsis type="placeholder" class="list-item-text">
                {{ item.publisherAt }}
              </ele-ellipsis>
            </div>
          </div>
        </div>
        <div v-if="notice.length" class="bottom-tools">
          <div class="bottom-tool" @click="clearNotice">清空通知</div>
          <el-divider direction="vertical" style="margin: 0; width: 0" />
          <router-link to="/user/message?type=notice" class="bottom-tool">
            查看更多
          </router-link>
        </div>
        <el-empty v-else description="已查看所有通知" :image-size="68" />
      </template>
      <template #letter>
        <div class="list-wrapper">
          <div v-for="item in letter" :key="item.id" class="list-item">
            <div
              style="
                display: flex;
                flex-direction: column;
                padding: 0 5px;
                align-items: center;
                justify-content: flex-start;
              "
              ><el-avatar :size="32" :src="item.senderAvatar" />
              <span>{{ item.senderUsername }}</span></div
            >
            <div class="list-item-body">
              <ele-ellipsis>{{ item.title }}</ele-ellipsis>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <ele-ellipsis type="placeholder" class="list-item-text">
                  <lzd-editor
                    v-model="item.content"
                    format="json"
                    :read-only="true"
                    :hide-box-shadow="true"
                    :hide-border="true"
                    :type="'richtext'"
                    :min-height="'18pt'"
                  />
                </ele-ellipsis>
                <el-button
                  style="margin-left: 5px"
                  size="small"
                  type="primary"
                  @click="handleSendMesg(item)"
                  >回复</el-button
                ></div
              >
              <ele-ellipsis type="placeholder" class="list-item-text">
                {{ item.senderAt }}
              </ele-ellipsis>
            </div>
          </div>
        </div>
        <div v-if="letter.length" class="bottom-tools">
          <div class="bottom-tool" @click="clearLetter">清空私信</div>
          <el-divider direction="vertical" style="margin: 0; width: 0" />
          <router-link to="/user/message?type=letter" class="bottom-tool">
            查看更多
          </router-link>
        </div>
        <el-empty v-else description="已读完所有私信" :image-size="68" />
      </template>
      <template #todo>
        <div class="list-wrapper">
          <div v-for="item in todo" :key="item.id" class="list-item">
            <div class="list-item-body">
              <ele-ellipsis>{{ item.title }}</ele-ellipsis>
              <ele-ellipsis type="placeholder" class="list-item-text">
                {{ item.content }}
              </ele-ellipsis>
            </div>
            <el-tag
              v-if="item.todoStatus === 0"
              type="info"
              size="small"
              :disable-transitions="true"
            >
              未开始
            </el-tag>
            <el-tag
              v-else-if="item.todoStatus === 1"
              type="danger"
              size="small"
              :disable-transitions="true"
            >
              即将到期
            </el-tag>
            <el-tag
              v-else-if="item.todoStatus === 2"
              size="small"
              :disable-transitions="true"
            >
              进行中
            </el-tag>
          </div>
        </div>
        <div v-if="todo.length" class="bottom-tools">
          <div class="bottom-tool" @click="clearTodo">清空待办</div>
          <el-divider direction="vertical" style="margin: 0; width: 0" />
          <router-link to="/user/message?type=todo" class="bottom-tool">
            查看更多
          </router-link>
        </div>
        <el-empty v-else description="已完成所有任务" :image-size="68" />
      </template>
    </ele-tabs>
  </ele-popover>
  <SendMsg
    v-model="showSendMsg"
    :data="sendUserisList"
    @done="readMessage([replayMsgSeq!])"
  />
  <!-- 预览 -->
  <notice-preview
    v-model="showPreview"
    :title="title"
    :data="currentNotices!"
    @done="query"
  />
</template>

<script lang="ts" setup>
  import { ref, computed, nextTick } from 'vue';
  import type { EleTabs } from 'ele-admin-plus';
  import { BellOutlined } from '@/components/icons';
  import { RParam } from '@/api';

  import systemMessageApi from '@/api/bsl/system/message';
  import {
    getAppId,
    getDataScopeId,
    getRoleCode,
    tipsError
  } from '@/utils/lzd-util';
  import tenantNoticeApi, {
    pageTenantNotices,
    queryTenantNoticeSingle
  } from '@/api/bsl/tenant/notice/list';

  import type { Message } from '@/api/bsl/system/message/model';
  import type { TenantNotice } from '@/api/bsl/tenant/notice/list/model';

  import SendMsg from '@/views/bsl/tenant/user/student/components/send-msg.vue';
  import NoticePreview from '@/views/bsl/tenant/notice/components/notice-preview.vue';

  /** 标签页 */
  const tabRef = ref<InstanceType<typeof EleTabs> | null>(null);

  /** 选项卡选中 */
  const active = ref<string>('notice');

  /** 通知数据 */
  const notice = ref<TenantNotice[]>([]);

  /** 私信数据 */
  const letter = ref<Message[]>([]);

  /** 待办数据 */
  const todo = ref<Message[]>([]);
  /** 预览通知公告 */
  const showPreview = ref(false);
  /** 当前编辑数据 */
  const currentNotices = ref<TenantNotice>();
  const title = ref('');

  /** 未读数量 */
  const unreadNum = computed(() => {
    return notice.value.length + letter.value.length + todo.value.length;
  });

  /** 查询数据 */
  const query = () => {
    systemMessageApi
      .queryUnreadMessage({ appId: getAppId(), dataScopeId: getDataScopeId() })
      .then((result) => {
        letter.value = result?.letter ?? [];
        todo.value = result?.todo ?? [];
      })
      .catch((err) => {
        tipsError(err);
      });
    // 查询通知公告
    pageTenantNotices({
      where: RParam.buildWhere({}),
      paged: false
    }).then((data) => {
      if (data?.list) {
        notice.value = data.list;
      }
    });
  };

  /** 清空通知 */
  const clearNotice = () => {
    updateActiveBar();
    tenantNoticeApi
      .readMsg(notice.value.map((v) => v.seq!))
      .then(() => {
        query();
      })
      .catch((err) => {
        tipsError(err);
      });
    notice.value = [];
  };

  /** 清空私信 */
  const clearLetter = () => {
    updateActiveBar();
    readMessage(letter.value.map((v) => v.seq!));
    letter.value = [];
  };

  /** 清空待办 */
  const clearTodo = () => {
    updateActiveBar();
    readMessage(todo.value.map((v) => v.seq!));
    todo.value = [];
  };

  const readMessage = (seqs: number[]) => {
    if (!seqs || seqs.length == 0) {
      return;
    }
    systemMessageApi
      .readMsg({
        pks: seqs,
        appId: getAppId(),
        dataScopeId: getDataScopeId(),
        roleCode: getRoleCode()
      })
      .then(() => {
        query();
      })
      .catch((err) => {
        tipsError(err);
      });
  };
  /** 更新标签页指示线 */
  const updateActiveBar = () => {
    nextTick(() => {
      tabRef.value?.updateActiveBar?.();
    });
  };

  const showSendMsg = ref(false);
  const replayMsgSeq = ref<number>();
  const sendUserisList = ref<string[]>([]);
  const handleSendMesg = (row: Message) => {
    sendUserisList.value = [row.senderUserid!];
    replayMsgSeq.value = row.seq;
    showSendMsg.value = true;
  };

  /** 预览通知公告 */
  const handleNoticesPreview = (row: TenantNotice) => {
    if (row == null) {
      return;
    }
    currentNotices.value = row;
    title.value = '预览通知公告';

    queryTenantNoticeSingle({ where: RParam.buildWhere({ id: row.id }) })
      .then((data) => {
        if (data) {
          currentNotices.value = data.data;
          title.value = '预览通知公告';
          showPreview.value = true;
        }
      })
      .catch((error) => {
        tipsError(error);
      });
  };

  query();
</script>

<style lang="scss" scoped>
  .list-wrapper {
    padding-top: 8px;
    box-sizing: border-box;
    max-height: calc(100vh - 180px);
    min-height: 60px;
    overflow: auto;
  }

  .list-item {
    display: flex;
    padding: 14px 24px;
    box-sizing: border-box;
    transition: background-color 0.2s;
    cursor: pointer;

    .list-item-body {
      flex: 1;
      overflow: hidden;

      .list-item-text {
        margin-top: 6px;
      }
    }

    .list-item-icon {
      width: 32px;
      height: 32px;
      color: #fff;
      font-size: 16px;
      border-radius: 50%;
      text-align: center;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(.el-avatar) {
      flex-shrink: 0;
    }

    .list-item-icon + .list-item-body,
    :deep(.el-avatar + .list-item-body) {
      padding-left: 12px;
    }

    &:hover {
      background-color: hsla(0, 0%, 60%, 0.08);
    }

    & + .list-item {
      border-top: 1px solid hsla(0, 0%, 60%, 0.2);
    }
  }

  /* 操作按钮 */
  .bottom-tools {
    display: flex;
    align-items: center;
    border-top: 1px solid hsla(0, 0%, 60%, 0.2);

    .bottom-tool {
      flex: 1;
      line-height: 46px;
      text-align: center;
      text-decoration: none;
      transition: background-color 0.3s;
      cursor: pointer;
      color: inherit;

      &:hover {
        background: hsla(0, 0%, 60%, 0.08);
      }
    }
  }

  /* 修改标签页样式 */
  .notice-tabs :deep(.el-tabs__header) {
    --ele-tab-height: 44px;
    --ele-tab-padding: 22px;
  }
</style>
